export default __webpack_public_path__ + "static/media/about.7fe4b198.svg";